// import icons
import clock from '../images/clock.png'
import workout from  '../images/workout.png'
import money from '../images/money.svg'
import teamwork from '../images/teamwork.svg' 
//styled
import { About , Description,  Image } from '../Styles'
import styled from 'styled-components'

export default function ServicesSection() {
    return (
        <Services>
        <Description>
          <h2>High <span>quality</span> services.</h2>
           <Cards>
               <Card>
                   <div className="icon">
                       <img src={clock} alt="icons"/>
                        <h3>Efficient</h3>
                   </div>
                   <p>Lorem ipsum dolor sit amet.</p>
               </Card>

               <Card>
                   <div className="icon">
                       <img src={workout} alt="icons"/>
                        <h3>Personal Trainer</h3>
                   </div>
                   <p>Lorem ipsum dolor sit amet.</p>
               </Card>

               <Card>
                   <div className="icon">
                       <img src={money} alt="icons"/>
                        <h3>Affordable</h3>
                   </div>
                   <p>Lorem ipsum dolor sit amet.</p>
               </Card>

               <Card>
                   <div className="icon">
                       <img src={teamwork} alt="icons"/>
                        <h3>Teamwork</h3>
                   </div>
                   <p>Lorem ipsum dolor sit amet.</p>
               </Card>
           </Cards>
        </Description>
        <Image>
            <img className="girl-images" src="https://cdn.bitrix24.in/b11172703/landing/da7/da7ff239b8b4aeab19f76594748b18ae/5511.jpg" alt="trainer-pic" />
        </Image>
       
        </Services>
    )
}

const Services = styled(About)`
h2{
    padding-bottom : 5rem;
}
p{
    width: 70%;
    padding: .5rem 0 4rem 0;
}

`

const Cards =  styled.div`
display: flex;
flex-wrap: wrap-reverse;
@media(max-width: 1300px){
justify-content: center;
p{
    width: 100%;
}
}
`
const Card = styled.div`
flex-basis : 20rem;
.icons{
    display: flex;
    align-items: center;
}
h3{
    font-size: 1.8rem;
}
`